// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar-module--navbar--1YOwv","logo":"Navbar-module--logo--2oFuN","menu_toggle":"Navbar-module--menu_toggle--2K0NM","desktop_nav":"Navbar-module--desktop_nav--2TpyY"};